export interface CartAppliedCoupon {
  applied_coupon: {
    code: boolean
    [key: string]: any
  }
}

export const cartAppliedCoupon = {
  applied_coupon: {
    code: true
  }
}
